import React from "react";

import LeftMenu from "@/mk2/apps/blogs/components/LeftMenu";

import { Props } from "./ListOfForumsPage";
import styles from "./ListOfForumsRight.mscss";

export class ListOfForumsRight extends React.PureComponent<Props> {
    public render() {
        const { location } = this.props;
        // TBD brand days
        return (
            <div className={styles.ListOfForumsRight}>
                <LeftMenu location={location} />
            </div>
        );
    }
}
